// @ngInject
export function noFocusOnClick($parse: ng.IParseService): ng.IDirective {
  return {
    restrict: "A",
    link: function (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: any) {
      element.mousedown((event) => {
        event.preventDefault();
      });
    }
  };
}
